// Libs
import React from 'react';
import cx from 'classnames';
// Components
import { EmptyIllustration } from 'components/Illustrations';
import FormComponentBuilder from './FormComponentBuilder';
import { getCustomOrderNumberState } from './customOrderNumber.utils';
// Styles
import styles from './DefaultForm.module.css';

const DefaultForm = ({
	isMobile,
	externalDisabled,
	form,
	values,
	empty,
	setValues,
	submitForm,
	getProcessedComponentSqlData,
	manualOrderTemplateSelection,
	templateSelectionBlocked,
	templateSelectionHidden,
	selectionContextKey,
	onTemplateSelectionStateChange,
}) => {
	const contractorRequiredParams = [
		'entityIdc',
		'entityName',
		'userIdc',
		'userName',
		'emailAddress',
		'phoneNumber',
	];
	const isContractorForm =
		form.key === 'createEntity' &&
		// The DB form key is shared by this legacy creation flow. Component params
		// are the stable cross-environment contract; form IDs and titles are not.
		contractorRequiredParams.every(param =>
			form.components.some(component => component.param === param),
		);
	const hasProjectAssignments =
		Array.isArray(values.projectAssignments) &&
		values.projectAssignments.length > 0;
	const contractorAssignmentsComponent = {
		id: 'contractor-project-assignments',
		param: 'projectAssignments',
		params: {},
		type: 'list',
		title: 'Proyecto y línea de negocio',
		placeholder: 'Seleccione los pares asignados',
		config: {},
	};
	const components = isContractorForm
		? form.components.reduce((acc, component) => {
				if (component.type === 'submit')
					acc.push(contractorAssignmentsComponent);
				acc.push(component);
				return acc;
			}, [])
		: form.components;

	if (empty)
		return (
			<EmptyIllustration
				title='Formulario no configurado'
				width={!isMobile ? '300px' : '100px'}
				fontSize='2em'
			/>
		);

	return (
		<div className={styles.defaultFormContainer}>
			{components.map(component => (
				<div
					key={component.id}
					className={cx(styles.defaultComponentContainer, {
						// Hide only the resolved unique choice; keep it mounted for scope reloads.
						[styles.noneDisplay]:
							manualOrderTemplateSelection &&
							component.param === 'createOrderTemplateId'
								? templateSelectionHidden
								: component.config?.hide ||
									getCustomOrderNumberState(component.config, values)
										?.visible === false,
					})}
				>
					<FormComponentBuilder
						key={component.id}
						externalDisabled={
							externalDisabled ||
							(component.type === 'submit' && templateSelectionBlocked) ||
							(isContractorForm &&
								component.type === 'submit' &&
								!hasProjectAssignments)
						}
						manualOrderTemplateSelection={manualOrderTemplateSelection}
						selectionContextKey={selectionContextKey}
						onTemplateSelectionStateChange={onTemplateSelectionStateChange}
						componentId={component.id}
						componentParam={component.param}
						params={component.params}
						config={component.config}
						type={component.type}
						title={component.title}
						placeholder={component.placeholder}
						values={values}
						setValues={setValues}
						submitForm={submitForm}
						sending={form.sending}
						getProcessedComponentSqlData={getProcessedComponentSqlData}
					/>
				</div>
			))}
		</div>
	);
};

export default DefaultForm;
